import { render, staticRenderFns } from "./NewRepositionWarningModal.vue?vue&type=template&id=6d9c64d3"
import script from "./NewRepositionWarningModal.vue?vue&type=script&lang=js"
export * from "./NewRepositionWarningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports